import React from "react";
import { AD_PLAN_CARDS } from "./constants";

/**
 * Step 3: advertising plan selection and Stripe Checkout.
 */
const VendorOnboardingStepPayment = ({
  formValues,
  formErrorsVendor,
  vendorPaymentComplete,
  agreementOnFile = false,
  handleSelectAdPlan,
  handlePayWithCard,
  handleContinueFromPayment,
  onBack,
}) => (
  <div className="col-md-12">
    <div className="bg-light rounded-3 p-3 mb-3">
      <h4 className="h5 mb-2">Payment</h4>
      <p className="small text-muted mb-3">
        Choose a 6- or 12-month vendor advertising plan, then pay securely with
        a card via Stripe Checkout. After payment succeeds,{" "}
        {agreementOnFile
          ? "you can finish — your vendor agreement signature is already on file from your first onboarding."
          : "continue to the agreement and signature step."}
      </p>
      {vendorPaymentComplete && (
        <div className="alert alert-success py-2 small mb-3" role="status">
          Payment received for your selected plan. Plan selection is locked so it
          stays aligned with what you paid.{" "}
          {agreementOnFile
            ? "Click Finish to submit this ad for review using your saved agreement."
            : "Continue to the agreement and signature step, or use Back to review earlier steps."}
        </div>
      )}

      <label className="form-label fw-semibold">Advertising plan</label>
      {vendorPaymentComplete && (
        <p className="small text-muted mb-2">
          You cannot change plans here after payment. A different term would
          require a new checkout (contact support if you need to adjust your
          purchase).
        </p>
      )}
      <div className="row g-3 mb-2">
        {AD_PLAN_CARDS.map((plan) => {
          const selected = formValues.adType === plan.value;
          const locked = vendorPaymentComplete;
          return (
            <div key={plan.value} className="col-md-6">
              <div
                role={locked ? undefined : "button"}
                tabIndex={locked ? -1 : 0}
                aria-disabled={locked}
                className={`h-100 rounded-3 border p-3 ${
                  selected
                    ? "border-primary border-2 shadow-sm bg-white"
                    : "border bg-white"
                }`}
                style={{
                  cursor: locked ? "default" : "pointer",
                  ...(locked && !selected ? { opacity: 0.65 } : {}),
                }}
                onClick={
                  locked ? undefined : () => handleSelectAdPlan(plan.value)
                }
                onKeyDown={
                  locked
                    ? undefined
                    : (ev) => {
                        if (ev.key === "Enter" || ev.key === " ") {
                          ev.preventDefault();
                          handleSelectAdPlan(plan.value);
                        }
                      }
                }
              >
                {locked && selected && (
                  <div className="badge bg-success text-white mb-2 small">
                    Paid for this plan
                  </div>
                )}
                <div className="fw-bold text-primary mb-1">{plan.title}</div>
                <div className="small text-muted mb-2">{plan.priceLine}</div>
                <p className="small mb-0">{plan.description}</p>
              </div>
            </div>
          );
        })}
      </div>
      {formErrorsVendor.adType && (
        <div className="text-danger small mb-0">{formErrorsVendor.adType}</div>
      )}

      <div className="d-flex flex-column flex-sm-row flex-wrap justify-content-between align-items-stretch align-items-sm-center gap-3 mt-4 pt-3 border-top w-100">
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          onClick={onBack}
        >
          Back
        </button>
        <div className="d-flex flex-column flex-sm-row gap-2 align-items-stretch align-self-sm-end">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={handlePayWithCard}
            disabled={vendorPaymentComplete}
          >
            {vendorPaymentComplete ? "Paid" : "Pay with card"}
          </button>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            onClick={handleContinueFromPayment}
            disabled={!vendorPaymentComplete}
          >
            {vendorPaymentComplete && agreementOnFile
              ? "Finish"
              : "Next step"}
            <i className="fi-chevron-right fs-sm ms-2"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default VendorOnboardingStepPayment;
